import {round} from 'lodash';

const Calculation = {
  percentage: ({ part, full }) => {
    const toOne  = [0, NaN, Infinity];
    const number = round(part / full * 100);

    return toOne.includes(number) ? 1 : number;
  },
};

export default Calculation;



// WEBPACK FOOTER //
// ./src/features/shared/utils/Calculation.js